export default __webpack_public_path__ + "static/media/line.0ede1af0.svg";